import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { IDeviceUpdateInfo } from 'lavva.exalushome/build/js/Services/Updates/IUpdateInfo';
import { UpdateProgressInfo, UpdateStatus } from 'lavva.exalushome/build/js/Services/Updates/IUpdatesService';
import { useBackdropContext } from '../../../../../context/backdrop';
import { langCode } from '../../../utils/updates';

export const useUpdateProcess = () => {
  const navigate = useNavigate();
  const { t, i18n } = useTranslation('device-info');
  const { turnOnBackdropPopup, turnOffBackdropPopup } = useBackdropContext();

  const onUpdateDeviceProgress = (updateProgress: UpdateProgressInfo, deviceUpdate?: IDeviceUpdateInfo | null) => {
    turnOnBackdropPopup({
      header: t('exalus.params.Version.update'),
      message: (
        <p>
          {t('exalus.params.Version.updateInProgress')} <span>{deviceUpdate?.NewResourceVersion || '-'}</span>
        </p>
      ),
      updateContent: {
        progress: updateProgress.Status === UpdateStatus.Upgraded ? 100 : updateProgress.PercentageTotal,
        status: updateProgress.Status,
        description: deviceUpdate?.UpdateDescription.get(langCode[i18n.language]),
        updateNumber: updateProgress.UpdateNumber,
        updatedResourceName: updateProgress.UpdatedResourceName.get(langCode[i18n.language]) || '',
        availableUpdates: [deviceUpdate?.UpdatedResourceName || ''],
        handleClose: () => {
          turnOffBackdropPopup();
          navigate(-1);
        },
      },
    });
  };

  return {
    onUpdateDeviceProgress,
  };
};
